import { render, staticRenderFns } from "./save-count.vue?vue&type=template&id=0f0e6884"
import script from "./save-count.vue?vue&type=script&lang=js"
export * from "./save-count.vue?vue&type=script&lang=js"
import style0 from "./save-count.vue?vue&type=style&index=0&id=0f0e6884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports